<eess-bienvenido></eess-bienvenido>
<div class="d-flex jc-c mt-5" *ngIf="previredIsCalled">
    <div class="bch-card ml-3 col-lg-8 col-md-11">
        <div class="body">
            <div class="ta-c">
                <h2 class="c-brand"><strong> Hemos verificado tus datos
                        correctamente.</strong>
                </h2>
            </div>
            <div class="ta-c">
                <h5 class="c-brand-light">Ahora necesitamos que nos entregues
                    tu permiso para continuar.</h5>
            </div>
            <div class="ta-c mt-3">
                <h3 class="c-brand-dark">Autorizo a consultar mis últimas cotizaciones previsionales.
                </h3>
            </div>
            <div class="bch-card card-big bch-card-secondary--neutral">
                <p class="mr-3">Por este acto, autorizo a mi AFP a
                    entregar por intermedio de Previred a Banco de Chile, para su
                    uso exclusivo y bajo confidencialidad, información sobre mis seis
                    últimos periodos cotizados en la AFP, como antecedente para evaluación
                    comercial, dando así cumplimiento al artículo 4° de la Ley N° 19.628 de
                    Protección de la Vida Privada.
                </p>
            </div>
            <div class="bch-multichoice">
                <mat-checkbox (change)="buttonActivated($event)" class="mt-5">Autorizo a
                    consultar mis cotizaciones.
                </mat-checkbox>
            </div>
            <div class="row mt-5 mt-sm-0">
                <div class="col-12 col-sm-8 col-md-4 mx-auto bch-button-auto-size">
                    <bch-button [disabled]="!checkBoxIsClicked" [button]="buttonContinuar" (clicked)="callsuccessMessage()"></bch-button>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!previredIsCalled">
    <div class="col-12 d-flex jc-c">
            <ng-lottie class="mr-6 mr-md-6" [options]="lottieInfo" width="140px" height="140px"></ng-lottie>
    </div>
    <div class="col-8 mx-auto mt-3">
        <h3 class="ta-c c-success-light">Felicidades, has completado la autenticación</h3>
    </div>

    <div class="d-flex jc-c mt-5">
        <div class="bch-card ml-3 col-lg-8 col-md-10">
            <div class="body">
                <div class="col-12">
                    <p [innerHTML]="successmessage" class="ta-c"></p>
                </div>

                <div class="d-flex jc-c mt-5">
                    <img class="img-fluid" src="assets/images/icons.svg">
                </div>
                
                <div class="row mt-5 mt-sm-0">
                    <div class="col-12 col-md-6 mx-auto col-xl-5 bch-button-auto-size">
                        <bch-button  [button]="buttonLlenarEess" (clicked)="callDirectiveEessPublico()"></bch-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>